/**
 * dir-w | backOffice
 * Shared component for filter collections
 *
 * Last update : January 22, 2024 | @rizkiprasetya
 */

import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';

@Component({
    selector: 'app-filter-collection',
    templateUrl: './filter-collection.component.html',
    styleUrl: './filter-collection.component.css',
    standalone: false
})
export class FilterCollectionComponent implements OnChanges {
  @Input() filterParams: Array<{ key: string; value: string }> = [];
  @Output() filterEvent = new EventEmitter<Array<{ key: string; value: string }>>();

  protected onlyTrashed: boolean = false;
  protected searchTerms: string = '';

  ngOnChanges(changes: SimpleChanges): void {
    this.filterParams.map((item) => {
      if (item.key === 'filterCriteria') {
        this.searchTerms = item.value;
      }
      if (item.key === 'filterTrashed') {
        this.onlyTrashed = true;
      }
    });
  }

  /**
   * Search data based on user search terms.
   * @param _clear If its valus is true, then clear / reset the user search terms
   */
  searchData(_clear: boolean): void {
    let found: boolean = false;
    let index: number = 0;
    this.filterParams.map((item) => {
      if (item.key === 'filterCriteria') {
        found = true;
        if (_clear) {
          this.searchTerms = '';
          this.filterParams.splice(index, 1);
        } else {
          item.value = this.searchTerms;
        }
      }
      index++;
    });

    // if not found add filterCriteria to Array HttpParams
    if (!found) {
      this.filterParams.push({
        key: 'filterCriteria',
        value: this.searchTerms,
      });
    }

    // send the result to collection page
    this.filterEvent.emit(this.filterParams);
  }

  /**
   * Search data with only trashed record include
   * @param _withTrashed If its valus is true, then search data with trashed include
   */
  searchWithTrashed(_onlyTrashed: boolean): void {
    let found: boolean = false;
    let index: number = 0;
    this.onlyTrashed = _onlyTrashed;
    this.filterParams.map((item) => {
      if (item.key === 'filterTrashed') {
        found = true;
        if (!_onlyTrashed) {
          this.filterParams.splice(index, 1);
        }
      }
      index++;
    });

    // if not found add filterTrashed to Array HttpParams
    if (!found) {
      this.filterParams.push({ key: 'filterTrashed', value: '' });
    }

    // send the result to collection page
    this.filterEvent.emit(this.filterParams);
  }
}
